import React, { useEffect } from 'react'
import styled from 'styled-components';
import GithubIcon from '@material-ui/icons/GitHub';
import LinkedIcon from '@material-ui/icons/LinkedIn';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import EmailIcon from '@material-ui/icons/Email';
import Particle from '../Components/Particle';
import { init } from 'ityped';
import { Wave1 } from '../data/examples.js';


function HomePage() {

    useEffect(() => {
        const myElement = document.querySelector('#myElement')
      	init(myElement, { showCursor: false, strings: ['Full Stack Web Developer', 'Software Engineer', '< Coder >' ] });
    },[]);
    return (
        <HomePageStyled>
            <div className="particle-con">
                <Particle />
            </div>
            <div className="typography">
                <h1> <Wave1 /> </h1>
                <h3>Hi, I'm a <span id='myElement'></span></h3>
                <div className="icons">
                    <a href="https://www.linkedin.com/in/karan-b1642a9a/" rel="noreferrer" target="_blank" className="icon i-youtube">
                        <LinkedIcon />
                    </a>
                    <a href="https://github.com/Karan-21" rel="noreferrer" target="_blank" className="icon i-github">
                        <GithubIcon />
                    </a>
                    <a href="mailto:karngupta21@gmail.com" rel="noreferrer" target="_blank" className="icon i-email">
                        <EmailIcon />
                    </a>
                    <a href="https://www.facebook.com/karn.gupta.90" rel="noreferrer" target="_blank" className="icon i-facebook">
                        <FacebookIcon />
                    </a>
                    <a href="https://www.instagram.com/karan.gupta.21/" rel="noreferrer" target="_blank" className="icon i-insta">
                        <InstagramIcon />
                    </a>
                </div>
            </div>
        </HomePageStyled>
    )
}

const HomePageStyled = styled.header`
    width: 100%;
    height: 100vh;
    position: relative;

    .typography{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        width: 80%;

        .icons{
            display: flex;
            justify-content: center;
            margin-top: 1rem;
            .icon{
                border: 2px solid var(--border-color);
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                transition: all .4s ease-in-out;
                cursor: pointer;
                &:hover{
                    border: 2px solid var(--primary-color);
                    color: var(--primary-color);
                }
                &:not(:last-child){
                    margin-right: 1rem;
                }
                svg{
                    margin: .5rem;
                }
            }

            .i-youtube{
                &:hover{
                    border: 2px solid red;
                    color: red;
                }
            }
            .i-github{
                &:hover{
                    border: 2px solid purple;
                    color: purple;
                }
            }
            .i-facebook{
                &:hover{
                    border: 2px solid blue;
                    color: blue;
                }
            }
            .i-insta{
                &:hover{
                    border: 2px solid green;
                    color: green;
                }
            }
            .i-email{
                &:hover{
                    border: 2px solid yellow;
                    color: yellow;
                }
            }
        }
    }
`;

export default HomePage;
